import dynamic from 'next/dynamic';
import React from 'react';
import useScreenSize from '../../hooks/useScreenSize';

const Banner = dynamic(() => import('./index'), { ssr: false });

export const getBannerConfig = (
  count: number,
  index: number,
  isSmall: boolean
) => {
  if (isSmall) {
    const isMobileSlot =
      index === count || (index > count && (index - count) % 30 === 0);

    if (isMobileSlot) {
      return {
        bn: '6',
        containerClassName:
          'lotriver-bottom-banner lotriver-search-banner content-banner',
        containerId: `js-lotriver-bottom-banner-${index}`
      };
    }
  } else if (index === count) {
    return {
      bn: '7',
      containerClassName: 'lotriver-search-banner content-banner',
      containerId: 'js-lotriver-search-banner'
    };
  }

  return null;
};

export const LotriverSearchResultBanner: React.FC<{
  currIndex: number;
  count: number;
}> = ({ currIndex, count }) => {
  const { isSmall } = useScreenSize();
  const bannerConfig = getBannerConfig(count, currIndex, isSmall);

  if (!bannerConfig) return null;

  return (
    <Banner
      tagName="p"
      sid="220686"
      arCn={Number(currIndex)}
      {...bannerConfig}
    />
  );
};
